module.exports = __webpack_public_path__ + "system/img/personal-icon-02.14b4fc73.png";